import React from 'react'

import Container from './Container'

type Props = {
    title: string,
    subtitle?: string,
    className?: string,
    mode: "light" | "dark",
}

const TitleRow = (props: Props) => {

    const titleClass = props.mode === "light" ? "text-gray-800" : "text-white"
    const subtitleClass = props.mode === "light" ? "text-gray-500" : "text-gray-300"

    return (
        <div className={`w-full font-roboto font-bold ${props.className}`}>
            <Container>
                <div className="w-full grid lg:grid-cols-2 items-center gap-4 max-lg:text-center">
                    <h2 className={`text-2xl lg:text-3xl xl:text-4xl ${titleClass}`}>{props.title}</h2>
                    {props.subtitle &&
                        <small className={`text-lg font-normal italic ${subtitleClass}`}>{props.subtitle}</small>
                    }
                </div>
            </Container>
        </div>
    )
}

TitleRow.defaultProps = {
    mode: "light",
    className: "",
}

export default TitleRow